import React from "react";
import './index.less'

export interface AppTabsProps {
	tabs: string[];
	defaultIndex?: number;
	onChange?: (index: number) => void;
}

export class AppTabs extends React.Component<AppTabsProps> {

	state = { activeIndex: this.props.defaultIndex || 0 };

	handleTabClick = (activeIndex: number) => {
		if (activeIndex === this.state.activeIndex) return;
		this.props.onChange && this.props.onChange(activeIndex)
		this.setState({ activeIndex });
	}

	renderList = () => {
		let { tabs } = this.props;
		let { activeIndex } = this.state;

		return (<ul className="app-tabs-list-ul">
			{tabs.map((tab: string, index) => {
				let className = `app-tab-item${index === activeIndex?'-active':''}`;
				return (<li className={className} key={index} onClick={() => this.handleTabClick(index)}>{tab}</li>);
			})}
		</ul>);
	}

	render() {
		return (<div className="app-tabs-container" >
			{this.renderList()}
		</div>)
	}
}


// WEBPACK FOOTER //
// ./src/qcc/AppTabs/index.tsx